<template>
  <div>
    <slot name="extras" />
    <el-select
      remote
      filterable
      v-model="inputValue"
      @change="handleInputConfirm"
      @focus="handleCheckFetch"
      :clearable="clearable"
      :disabled="disabled"
      :default-first-option="true"
      :remote-method="remoteMethod"
      :style="styleValue"
      :placeholder="errorMsg || placeholder"
      :loading="loading"
      :size="$xUISize"
    >
      <el-option
        v-for="item in selectOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    defaultFirst: {
      type: Boolean,
      default: false,
    },
    styleValue: {
      type: String,
      default: "width: 100%",
    },
    managerable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: String
    },
  },
  watch: {
    value() {
      this.initValue();
    },
  },
  mounted() {
    this.initValue();
    this.remoteMethod("");
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      selectOptions: [],
      inputValue: "",
    };
  },
  methods: {
    initValue() {
      this.inputValue = this.value == "0" ? '' : this.value;
    },
    handleCheckFetch() {
      if (!this.selectOptions || this.selectOptions.length <= 0) {
        this.remoteMethod("");
      }
    },
    handleInputConfirm() {
      this.$emit("change", this.inputValue == '0' ? '' : this.inputValue);
    },
    remoteMethod(query) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.selectOptions = [];
      this.requestApi("biz.customer.supplier.info.list", {
        nameLike: query
      }).then((resp) => {
        this.loading = false;
        this.selectOptions = [];
        this.selectOptions.push(...(resp.data.list || []).map((item) => {
          return {
            value: item.guid,
            label: item.optVet == 1 ? item.name + " [兽药]" : item.name,
            default: item.optDefault == 1,
            vet: item.optVet == 1
          };
        }))
        if (this.selectOptions.map(item => item.value).indexOf(this.value) < 0) {
          this.inputValue = "";
          if (this.defaultFirst) {
            this.selectOptions.forEach(item => {
              if (item.default) {
                this.inputValue = item.value;
              }
            });
            if (!this.inputValue && this.selectOptions.length > 0) {
              this.inputValue = this.selectOptions[0].value;
            }
          }
          this.handleInputConfirm();
        }
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
      });
    },
  },
};
</script>